var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "canvasBox" }, [
      _c("div", { staticClass: "spinnerSexBox p1" }),
      _c("div", { staticClass: "spinnerSexBox p2" }),
      _c("div", { staticClass: "spinnerSexBox p3" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }